// extracted by mini-css-extract-plugin
export default {"leftText":"OCjdc","rightText":"UhMQc"};